import React, {useState} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';

function TestOptionsResult({name, metadata = []}) {
    const components = []
    const [value, setValue] = useState(null)

    for(let i = 0; i < metadata.length; i++) {
        components.push((
            <Row key={`compoennt_test_row_${i}`}>
                <Circle onClick={() => setValue(i)} active={i === value} />
                <Text
                    key={`input_${i}`}
                    type='text'
                >
                    {metadata[i]}
                </Text>
            </Row>
        ))
    }

    return (
        <Wrapper>


            {components}

            <input type={'hidden'} name={name} value={value} />
        </Wrapper>
    );
}

export default TestOptionsResult;

const Circle = styled.div`
    border: 1px solid #FA9F63;
    width: 18px;
    height: 18px;
    border-radius: 24px;
    margin-right: 8px;
    cursor: pointer;
    background-color: ${props => props.active ? '#FA9F63' : 'none'};
`

const RemoveButton = styled.div`
  position: absolute;
  cursor:pointer;
  margin-left: 174px;
  margin-top: -8px;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
   flex-wrap: wrap;
`

const ButtonAdd = styled.button`
    border-radius: 4px;
    color: #FA9F63;
    padding-right: 8px;
    padding-left: 8px;
    cursor: pointer;
    background-color: transparent;
    border: 1px solid #FA9F63;
    margin-left: 8px;

    &:hover {
      background-color: #FA9F63;
      color: white;

    }

`

const Text = styled.div`

`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 6px;
  padding-bottom: 6px;
`



if (document.getElementsByTagName('test-options-result')) {
    const elements = document.getElementsByTagName('test-options-result')

    for(let element of elements) {
        const metadata = JSON.parse(element.attributes.questions.value)
        ReactDOM.render(
            <TestOptionsResult
                name={element.attributes.name && element.attributes.name.value}
                metadata={metadata} />, element);
    }

}
